import React from 'react';
import { Button, MenuItem, Select, Typography, Box } from '@mui/material';

const BulkEmailingPage = () => {
 return (
 <div className="min-h-screen bg-bgMain text-body flex items-start justify-center py-16 relative overflow-hidden font-sans">
 <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
 
 <div className="w-[90%] max-w-6xl bg-bgSection p-10 md:p-12 rounded-[32px] shadow-2xl border border-primary/30 relative overflow-hidden z-10"
 style={{ boxShadow:"0 20px 50px rgba(0, 0, 0, 0.3)" }}>
 
 <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-3xl"></div>
 
 {/* Header and Dropdown */}
 <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-12">
 <Typography variant="h4" sx={{ color:"var(--primary-blue, #4F46E5)", fontWeight: 900, textTransform:"uppercase", letterSpacing:"1px" }}>
 Bulk Communication
 </Typography>
 <Select
 defaultValue="All Users"
 variant="outlined"
 className="bg-bgMain text-body w-full md:w-72"
 sx={{
 color: '#fff',
 borderRadius: 3,
 '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.1)' },
 '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--primary-blue, #4F46E5)' },
 '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--primary-blue, #4F46E5)' },
 '& .MuiSelect-icon': { color: '#22D3EE' }
 }}
 >
 <MenuItem value="All Users" sx={{ background: '#0F172A', color: '#fff', '&:hover': { background: 'var(--primary-blue, #4F46E5)' } }}>All Users</MenuItem>
 <MenuItem value="Students" sx={{ background: '#0F172A', color: '#fff', '&:hover': { background: 'var(--primary-blue, #4F46E5)' } }}>Students</MenuItem>
 <MenuItem value="Colleges" sx={{ background: '#0F172A', color: '#fff', '&:hover': { background: 'var(--primary-blue, #4F46E5)' } }}>Colleges</MenuItem>
 </Select>
 </div>

 {/* Templates Row */}
 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
 <div className="p-8 bg-gradient-to-br from-primary to-secondary rounded-3xl shadow-xl cursor-pointer hover:scale-[1.03] transition-all relative group overflow-hidden">
 <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity"></div>
 <h3 className="text-white font-black text-xl mb-3 uppercase tracking-tighter">Onboarding Template</h3>
 <p className="text-white/80 text-sm font-medium leading-relaxed">Welcome new users to the platform with automated onboarding steps...</p>
 </div>
 
 <div className="p-8 bg-bgMain border border-accentGray/30 rounded-3xl shadow-xl cursor-pointer hover:scale-[1.03] hover:border-primary transition-all group">
 <h3 className="text-primary font-black text-xl mb-3 uppercase tracking-tighter group-hover:text-primary transition-colors">Premium Upgrade</h3>
 <p className="text-muted text-sm font-medium leading-relaxed group-hover:text-body transition-colors">Notify users about premium features and exclusive subscription discounts...</p>
 </div>

 <div className="p-8 bg-bgMain border border-accentGray/30 rounded-3xl shadow-xl cursor-pointer hover:scale-[1.03] hover:border-secondary transition-all group">
 <h3 className="text-primary font-black text-xl mb-3 uppercase tracking-tighter group-hover:text-white transition-colors">Event Reminder</h3>
 <p className="text-muted text-sm font-medium leading-relaxed group-hover:text-body transition-colors">Send alerts for upcoming hackathons, contests, and live bootcamp sessions...</p>
 </div>
 </div>

 {/* Buttons Row */}
 <div className="flex flex-col sm:flex-row justify-between items-center gap-6 pt-8 border-t border-accentGray/30">
 <Button
 variant="outlined"
 sx={{
 borderColor: 'rgba(34, 211, 238, 0.3)',
 color: '#22D3EE',
 fontWeight: '900',
 px: 4,
 py: 1.5,
 borderRadius: 3,
 textTransform: 'uppercase',
 letterSpacing: '1px',
 '&:hover': { borderColor: '#22D3EE', backgroundColor: 'rgba(34, 211, 238, 0.05)' }
 }}
 >
 + New Template
 </Button>

 <Button
 variant="contained"
 sx={{
 background: 'linear-gradient(90deg, var(--primary-blue, #4F46E5), #7C3AED)',
 color: '#fff',
 fontWeight: '900',
 px: 6,
 py: 1.5,
 borderRadius: 3,
 textTransform: 'uppercase',
 letterSpacing: '1px',
 boxShadow: '0 10px 25px rgba(37, 99, 235, 0.4)',
 '&:hover': { opacity: 0.9, transform: 'translateY(-1px)' },
 transition: 'all 0.2s'
 }}
 >
 Dispatch Emails
 </Button>
 </div>
 </div>
 </div>
 );
};

export default BulkEmailingPage;




